import { combineReducers } from 'redux';
import feed from './feed';

const hashtagReducer = combineReducers({
    feed
});

export default hashtagReducer;